import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TimelineNavHelperService } from '../../../../_helpers/timeline-nav-helper/timeline-nav-helper.service';
import { LearningSectionFlowControlHelperService } from '../../../../_helpers/learning-section-flow-control-helper/learning-section-flow-control-helper.service';
import { BaseLearningSectionComponent } from '../../../../shared/learning-section/base-learning-section/base-learning-section.component';

@Component({
    selector: 'milestone-section',
    templateUrl: './milestone-section.component.html',
    styleUrls: ['./milestone-section.component.css'],
    standalone: false
})
export class MilestoneSectionComponent extends BaseLearningSectionComponent implements OnInit {

  @Input("date") date: string;
  @Input("title") title: string;
  public milestoneLabel: string = '';
  public anchor: string;

  private year: number;
  private month: number;
  private scrollTop: number;

  constructor(
    private el: ElementRef,
    private timelineNavService: TimelineNavHelperService,
    protected readonly flowHelperService: LearningSectionFlowControlHelperService,
    public dialog: MatDialog,
    public container: ViewContainerRef) {
      super(flowHelperService, dialog);
  }

  @HostListener("window:scroll")
  scrollFn() {
    
    if (this.month == 1 && this.timelineNavService.isNavigating == false) {
      
      let top = this.el.nativeElement.getBoundingClientRect().top;

      if (top > 10 && top < 150) {
        this.timelineNavService.YearForward();
      }

      if (top > 151 && top < 350) {
        this.timelineNavService.YearBack();
      }
    }
  }


  ngOnInit() {
    this.year = +(this.timelineSection.sectionDate.substring(0, 4));
    this.month = +(this.timelineSection.sectionDate.substring(5, 7));
  }


}
